
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/model/german",
      function () {
        return require("private-next-pages/model/german.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/model/german"])
      });
    }
  